import { MetricConfig } from '../types/metrics';

export const metricsConfig: MetricConfig[] = [
  // ===== STAT CARDS =====
  
  // 1. PRODUCTOS VENDIDOS
  {
    id: 'products-sold',
    title: 'Productos vendidos',
    type: 'stat-card',
    sections: ['general', 'ventas'],
    positions: {
      general: { x: 0, y: 0, w: 1, h: 1 },
      ventas: { x: 0, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/total-products',
    enabled: true
  },
  
  // 2. TOTAL DE ÓRDENES
  {
    id: 'total-orders',
    title: 'Total de órdenes',
    type: 'stat-card',
    sections: ['general', 'ventas'],
    positions: {
      general: { x: 1, y: 0, w: 1, h: 1 },
      ventas: { x: 1, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/total-orders',
    enabled: true
  },
  
  // 3. TOTAL VENTAS ($)
  {
    id: 'total-sales',
    title: 'Total ventas ($)',
    type: 'stat-card',
    sections: ['general', 'ventas'],
    positions: {
      general: { x: 2, y: 0, w: 1, h: 1 },
      ventas: { x: 2, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/total-sales',
    enabled: true
  },
  
  // 4. TOTAL CYD (UNIDADES)
  {
    id: 'total-cyd-units',
    title: 'Total CyD (unid.)',
    type: 'stat-card',
    sections: ['general', 'cyd'],
    positions: {
      general: { x: 0, y: 1, w: 1, h: 1 },
      cyd: { x: 0, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/total-qty',
    enabled: true
  },
  
  // 5. ÓRDENES CON CYD
  {
    id: 'orders-with-cyd',
    title: 'Órdenes con CyD',
    type: 'stat-card',
    sections: ['general', 'cyd', 'operaciones'],
    positions: {
      general: { x: 1, y: 1, w: 1, h: 1 },
      cyd: { x: 1, y: 0, w: 1, h: 1 },
      operaciones: { x: 0, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/orders-count',
    enabled: true
  },
  
  // 6. TASA CYD (%)
  {
    id: 'cyd-rate',
    title: 'Tasa CyD (%)',
    type: 'stat-card',
    sections: ['general', 'cyd'],
    positions: {
      general: { x: 0, y: 2, w: 1, h: 1 },
      cyd: { x: 0, y: 1, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/rate',
    enabled: true
  },

  // 7. TOTAL CYD ($)
  {
    id: 'total-cyd-amount',
    title: 'Total CyD ($)',
    type: 'stat-card',
    sections: ['general', 'cyd'],
    positions: {
      general: { x: 2, y: 1, w: 1, h: 1 },
      cyd: { x: 2, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/total-amount',
    enabled: true
  },

  // 8. TASA CYD ($)
  {
    id: 'cyd-rate-amount',
    title: 'Tasa CyD ($)',
    type: 'stat-card',
    sections: ['general', 'cyd'],
    positions: {
      general: { x: 1, y: 2, w: 1, h: 1 },
      cyd: { x: 1, y: 1, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/rate-amount',
    enabled: true
  },

  {
    id: 'avg-days-sale-to-cyd',
    title: 'Tiempo medio venta → CyD',
    type: 'stat-card',
    sections: ['cyd'],
    positions: {
      cyd: { x: 2, y: 1, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/avg-days-sale-to-cyd',
    enabled: true
  },

  // 9. ÓRDENES POR ESTADO (Gráfico de Torta)
  {
    id: 'orders-by-status',
    title: 'Órdenes por estado',
    type: 'chart',
    chartType: 'pie',
    sections: ['general'],
    positions: {
      general: { x: 0, y: 4, w: 2, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/orders-by-status',
    enabled: true
  },

  // ===== GRÁFICOS =====
  
  // 1. SALES TREND
  {
    id: 'sales-trend',
    title: 'Tendencia de ventas',
    type: 'chart',
    chartType: 'line',
    sections: ['ventas'],
    positions: {
      ventas: { x: 0, y: 1, w: 3, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/sales-trend',
    enabled: true
  },
  
  // 2. CYD TREND
  {
    id: 'cyd-trend',
    title: 'Tendencia CyD',
    type: 'chart',
    chartType: 'line',
    sections: ['cyd'],
    positions: {
      cyd: { x: 0, y: 2, w: 4, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/trend-qty',
    enabled: true
  },

  {
    id: 'cyd-cohort-rate',
    title: 'Tasa CyD por cohorte de venta',
    type: 'chart',
    chartType: 'line',
    sections: ['cyd'],
    positions: {
      cyd: { x: 0, y: 4, w: 4, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/cohort-rate',
    enabled: true
  },
  
  // 3. TOP PRODUCTS
  {
    id: 'top-products',
    title: 'Top 10 productos',
    type: 'tabbed-table',
    sections: ['ventas'],
    positions: {
      ventas: { x: 0, y: 4, w: 3, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/top-products',
    enabled: true
  },

  {
    id: 'orders-table',
    title: 'Órdenes recientes',
    type: 'table',
    sections: [],
    positions: {
      ventas: { x: 0, y: 4, w: 4, h: 3 }
    },
    apiEndpoint: '/api/metrics/{storeId}/orders/table',
    enabled: true
  },
  
  // 4. CYD BY REASON
  {
    id: 'cyd-by-reason',
    title: 'CyD por motivo',
    type: 'chart',
    chartType: 'stacked-bar',
    sections: ['cyd'],
    positions: {
      cyd: { x: 0, y: 6, w: 2, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/by-reason',
    enabled: true
  },
  
  // 5. TOP CYD PRODUCTS
  {
    id: 'top-cyd-products',
    title: 'Top 10 productos CyD',
    type: 'tabbed-table',
    sections: ['cyd'],
    positions: {
      cyd: { x: 0, y: 8, w: 2, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/products-table',
    enabled: true
  },
  
  // 6. CYD DISTRIBUTION
  {
    id: 'cyd-distribution',
    title: 'Distribución CyD',
    type: 'chart',
    chartType: 'pie',
    sections: ['cyd'],
    positions: {
      cyd: { x: 2, y: 6, w: 2, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/distribution',
    enabled: true
  },
  
  // 7. TOP 10 CLIENTES CON MAYOR TASA DE CYD
  {
    id: 'top-customers-cyd-rate',
    title: 'Top 10 clientes con mayor tasa CyD',
    type: 'table',
    sections: ['cyd'],
    positions: {
      cyd: { x: 2, y: 8, w: 2, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/top-customers-cyd-rate',
    enabled: true
  },
  
  // 8. ÓRDENES ABIERTAS (Operaciones)
  {
    id: 'open-orders',
    title: 'Órdenes abiertas en Boris',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 1, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/open-orders',
    enabled: true
  },
  {
    id: 'avg-resolution-time',
    title: 'Tiempo promedio resolución',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 2, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/avg-resolution-time',
    enabled: true
  },
  {
    id: 'orders-by-courier',
    title: 'Órdenes por método de envío',
    type: 'chart',
    chartType: 'pie',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 2, y: 1, w: 2, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/orders-by-courier',
    enabled: true
  },
  {
    id: 'orders-by-logistics',
    title: 'Órdenes por empresa de logística',
    type: 'chart',
    chartType: 'pie',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 0, y: 3, w: 2, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/orders-by-logistics',
    enabled: true
  },
  {
    id: 'total-shipping-cost',
    title: 'Costo total de envío',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 2, y: 3, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/total-shipping-cost',
    enabled: true
  },
  {
    id: 'average-shipping-cost',
    title: 'Costo promedio envío',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 3, y: 3, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/average-shipping-cost',
    enabled: true
  },
  {
    id: 'average-shipping-cost-sucursal',
    title: 'Costo promedio sucursal',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 2, y: 4, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/average-shipping-cost-sucursal',
    enabled: true
  },
  {
    id: 'average-shipping-cost-domicilio',
    title: 'Costo promedio domicilio',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 3, y: 4, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/average-shipping-cost-domicilio',
    enabled: true
  },
  {
    id: 'total-shipping-quoted',
    title: 'Total Cotizado',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 0, y: 5, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/total-shipping-quoted',
    enabled: true
  },
  {
    id: 'total-shipping-collected',
    title: 'Total Cobrado',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 1, y: 5, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/total-shipping-collected',
    enabled: true
  },
  {
    id: 'shipping-collection-gap',
    title: 'Desvío Cobro vs Costo',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 2, y: 5, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/shipping-collection-gap',
    enabled: true
  },
  {
    id: 'shipping-quoted-collection-gap',
    title: 'Desvío Cobro vs Cotizado',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 3, y: 5, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/shipping-quoted-collection-gap',
    enabled: true
  },
  {
    id: 'cambios-x-cupon',
    title: 'Cambios × cupón',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 0, y: 6, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/cambios-x-cupon',
    enabled: true
  },
  {
    id: 'devoluciones-x-cupon',
    title: 'Devoluciones × cupón',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 1, y: 6, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/devoluciones-x-cupon',
    enabled: true
  },
  {
    id: 'total-coupon-amount-issued',
    title: '$ emitidos en cupones',
    type: 'stat-card',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 2, y: 6, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/total-coupon-amount-issued',
    enabled: true
  },
  {
    id: 'cyd-requests-by-status',
    title: 'Solicitudes Abiertas por Estado',
    type: 'chart',
    chartType: 'pie',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 0, y: 1, w: 2, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/requests-by-status',
    enabled: true
  },
  {
    id: 'cyd-requests-table',
    title: 'Solicitudes de cambio y devolución',
    type: 'table',
    sections: ['operaciones'],
    positions: {
      operaciones: { x: 0, y: 5, w: 4, h: 3 }
    },
    apiEndpoint: '/api/metrics/{storeId}/cyd/requests-table',
    enabled: false
  },

  // ===== SECCIÓN CLIENTES =====
  
  // 1. TOTAL CLIENTES
  {
    id: 'total-customers',
    title: 'Total clientes',
    type: 'stat-card',
    sections: ['clientes'],
    positions: {
      clientes: { x: 0, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/customers/total',
    enabled: true
  },
  
  // 2. CLIENTES NUEVOS
  {
    id: 'new-customers',
    title: 'Clientes nuevos',
    type: 'stat-card',
    sections: ['clientes'],
    positions: {
      clientes: { x: 1, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/customers/new',
    enabled: true
  },
  
  // 3. CLIENTES RECURRENTES
  {
    id: 'recurring-customers',
    title: 'Clientes recurrentes',
    type: 'stat-card',
    sections: ['clientes'],
    positions: {
      clientes: { x: 2, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/customers/recurring',
    enabled: true
  },
  
  // 4. TASA DE RETENCIÓN
  {
    id: 'retention-rate',
    title: 'Tasa retención (%)',
    type: 'stat-card',
    sections: ['clientes'],
    positions: {
      clientes: { x: 3, y: 0, w: 1, h: 1 }
    },
    apiEndpoint: '/api/metrics/{storeId}/customers/retention-rate',
    enabled: true
  },
  
  // 5. TOP 10 CLIENTES (Período e Histórico)
  {
    id: 'top-customers',
    title: 'Top 10 clientes',
    type: 'tabbed-table',
    sections: ['clientes'],
    positions: {
      clientes: { x: 0, y: 1, w: 4, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/customers/top',
    enabled: true,
    tabs: [
      { id: 'period', label: 'Período', apiEndpoint: '/api/metrics/{storeId}/customers/top' },
      { id: 'historical', label: 'Histórico', apiEndpoint: '/api/metrics/{storeId}/customers/top-historical' }
    ]
  },
  
  // 6. CLIENTES POR TIPO
  {
    id: 'customers-by-type',
    title: 'Clientes por tipo',
    type: 'tabbed-table',
    sections: ['clientes'],
    positions: {
      clientes: { x: 0, y: 3, w: 4, h: 2 }
    },
    apiEndpoint: '/api/metrics/{storeId}/customers/top',
    enabled: true,
    tabs: [
      { id: 'new', label: 'Nuevos Clientes', apiEndpoint: '/api/metrics/{storeId}/customers/top-new' },
      { id: 'recurring', label: 'Recurrentes', apiEndpoint: '/api/metrics/{storeId}/customers/top-recurring' }
    ]
  },
  

  

];

// ===== FUNCIONES UTILITARIAS =====
export const getEnabledMetrics = () => metricsConfig.filter(m => m.enabled);

export const getMetricById = (id: string): MetricConfig | undefined => {
  return metricsConfig.find(m => m.id === id);
};

export const getMetricsBySection = (section: string): MetricConfig[] => {
  return getEnabledMetrics().filter(m => m.sections.includes(section as any));
}; 